import DragAndDropService from "../../../service/dragAndDrop";
import { closeDragAndDropSessionWarningModal } from "../../../store/dragAndDrop";
import { useAppDispatch } from "../../../store/hooks";
import labels from "../../../utils/labels";
import StandardButton from "../../UI/buttons/StandardButton";
import Modal from "../../UI/Modal";
import Overlay from "../../UI/Overlay";
import Body2 from "../../UI/textFields/Body2";
import Header2 from "../../UI/textFields/Header2";

const SessionWarningModal = () => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closeDragAndDropSessionWarningModal());
  };
  return (
    <Overlay darkBackground clickAway={handleClose} zIndex={1001}>
      <Modal>
        <Header2>{labels.endingDragAndDropSessionWaningHeader}</Header2>
        <Body2>{labels.endingDragAndDropSessionWaningText}</Body2>
        <div className="flex justify-end gap-[--spacing-md] w-full">
          <StandardButton variant="SECONDARY" onClick={handleClose}>
            {labels.returnToDragAndDropEdit}
          </StandardButton>
          <StandardButton
            variant="PRIMARY"
            onClick={() => {
              DragAndDropService.shutDownSession(dispatch);
              handleClose();
            }}
          >
            {labels.deleteDragAndDropCustomPlan}
          </StandardButton>
        </div>
      </Modal>
    </Overlay>
  );
};

export default SessionWarningModal;
